<template>
	<div id="app">
		<div class="view">
			<router-view />
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex'

	export default {
		name: 'app',
		data() {
			return {}
		},
		methods: {},
		computed: {

		},
		// lifecycle
		created () {

		},
		mounted () {
		}
	}
</script>
<style src="./assets/css/base.css"></style>
<style>
	body {
		height: 100%;
		position: relative;
		background-color: #ffffff;
	}

	body, button, input, select, textarea {
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue?88f0f9ea